import { WorkflowHandler } from "./WorkflowHandler";
import $ from "jquery";
import flatpickr from "flatpickr";
import confirmDatePlugIn from "flatpickr/dist/plugins/confirmDate/confirmDate";
import Swal from "sweetalert2";
import { Modal } from "bootstrap";
import { BlockPageHelper } from "../Helpers/helpers";
import { WOWorkflowActionNames } from "../WorkOrder/WOWorkflowActionNames";
const Genesis = require("../Genesis.js");

interface Dates {
    actualStartDate: string;
    actualFinishDate: string;
    propertyName: string;
    workOrderName: string;
    assetName: string;
    workOrderDescription: string;
    engineerName: string;
}

export class WorkflowWorkOrderApproveConditionHandler {
    private CONDITION_NAME = 'WorkOrderApproveCondition';

    private failingCondition: any;
    private validationMessage = '';
    private recordId = 0;
    private actionName = '';
    private containerSelector = '';
    private modal: Modal|null  = null;
    private autoReload = true;
    private actualStartDate = '';
    private actualFinishDate = '';
    private title = '';
    private signature: any = null;
     
    private promptUserForMessage(): void {
        $.get(Genesis.url('/Workflow/GetWorkOrderActualStartEndDate?workOrderId=' + this.recordId))
            .then((dates: Dates) => {
                this.actualStartDate = dates.actualStartDate;
                this.actualFinishDate = dates.actualFinishDate;

                $.get(Genesis.url('/Workflow/WorkOrderApprove?dropdownSystemCode=' + (this.failingCondition.dropdownCode ?? "") + '&recordId=' + this.recordId))
                    .then((html) => {
                        const hasModalEngineerName = html.includes('id="modalEngineerName"');
                        
                        if (hasModalEngineerName) {
                            const match = html.match(/id="modalEngineerName"\s+value="([^"]*)"/);
                        }

                        this.displayModal(html, dates);
                    });
            })
            .catch((error) => {
                console.error('Error fetching work order details:', error);
            });
    };
    
    private saveMessage(): void {
        this.blockPageAndDisableButtons();
        const formData = this.collectFormData();

        $.ajax({
            url: Genesis.url('/Workflow/SaveWorkOrderApprove'),
            type: 'POST',
            contentType: 'application/json',
            data: JSON.stringify(formData),
            traditional: true
        })
            .then(() => this.handlePostSuccess())
            .catch((error: any) => {
                console.error('Error saving work order approval:', error);
                this.handlePostError(error);
            });
    }

    private blockPageAndDisableButtons(): void {
        BlockPageHelper.block();
        WorkflowHandler.disableButtons();
    }

    private collectFormData(): any {
        const reason = $('#reasonType option:selected').val();
        const comment = $('#message').val();
        const changeDate = $('#statusChangeDate').val();
        const completeSR = $('#completeSR').val();
        const dateCompletion = $('#dateCompletion').val();
        const engineerName = $('#engineerName').val();
        const requiresClientSignOff = $('#requiresClientSignOff').is(':checked');
        const customerName = $('#customerName').val();
        let signatureValue = '';
        
        if (this.signature !== null && requiresClientSignOff) {
            signatureValue = this.signature.value();
        }

        const formData = {
            recordId: this.recordId,
            message: comment,
            reasonId: reason === '' ? null : reason,
            changeDate: changeDate === '' ? null : changeDate,
            completeSR: completeSR === '' ? null : completeSR,
            mode: this.failingCondition.mode,
            isMessageMandatory: this.failingCondition.isMessageMandatory === '' ? false : this.failingCondition.isMessageMandatory,
            actionName: this.actionName,
            dateCompletion: dateCompletion === '' ? null : dateCompletion,
            engineerName: engineerName,
            requiresClientSignOff: requiresClientSignOff,
            customerName: requiresClientSignOff ? customerName : null,
            signature: requiresClientSignOff ? signatureValue : null
        };
        
        return formData;
    }

    private handlePostSuccess(): void {
        if (this.modal !== null) {
            this.modal.hide();

            const followOnWorkOrderId = $('#followOnWorkOrderId').val() as string;
            if (this.actionName === WOWorkflowActionNames.ACTION_WorkDone && followOnWorkOrderId) {
                Swal.fire({
                    title: 'Follow-On Work Order Created',
                    text: 'A new Work Order and Quote have been created for the follow-on work.',
                    icon: 'success',
                    confirmButtonText: 'Go to New Work Order'
                }).then(() => {
                    window.location.href = Genesis.url('/WorkOrder/View?id=' + followOnWorkOrderId);
                });
                return;
            }

            let redirectToUrl = '';
            if (this.actionName === WOWorkflowActionNames.ACTION_WorkDone || this.actionName === WOWorkflowActionNames.ACTION_ReturnWorkOrder || this.actionName === WOWorkflowActionNames.ACTION_RiskAssessmentFailed) {
                redirectToUrl = Genesis.url(`/Summary/Index`);
            }
            WorkflowHandler.handleActionButton({}, this.recordId, this.actionName, this.autoReload, redirectToUrl);
        }
    }

    private handlePostError(error?: any): void {
        BlockPageHelper.unblock();
        let errorMessage = "An error occurred updating the Work Order. Please try again.";

        if (error && error.responseJSON) {
            if (error.responseJSON.error) {
                errorMessage = error.responseJSON.error;
            } else if (error.responseJSON.message) {
                errorMessage = error.responseJSON.message;
            }
        } else if (error && error.responseText) {
            try {
                const responseJson = JSON.parse(error.responseText);
                if (responseJson.error) {
                    errorMessage = responseJson.error;
                } else if (responseJson.message) {
                    errorMessage = responseJson.message;
                }
            } catch (e) {
                errorMessage = error.responseText || errorMessage;
            }
        } else if (error && error.statusText) {
            errorMessage = error.statusText;
        }

        Swal.fire({ 
            title: "Workflow Error", 
            text: errorMessage,
            icon: "error"
        });
    }

    private displayModal(html: string, dates: Dates) {
        html = this.replacePlaceholders(html);
        this.insertHtmlIntoModalPlaceholder(html);
        this.initializeModal();
        this.handleUserMessageSubmit();
        this.configureModalElements();
        this.initializeSignature();
        this.updateWorkOrderDetails(dates);
    }

    private replacePlaceholders(html: string): string {
        const replacements: { [key: string]: string } = {
            "#: title #": this.title,
            "#: action #": this.actionName,
            "#: message #": this.validationMessage,
            "#: headerCss #": this.ComposeHeaderCss(),
            "#: headerIconCss #": this.ComposeHeaderIconCss(),
            "#: commentTitle #": this.actionName === WOWorkflowActionNames.ACTION_WorkDone ? "Summary of work carried out" : "Comment"
        };

        for (const placeholder in replacements) {
            const regex = new RegExp(placeholder, 'g');
            html = html.replace(regex, replacements[placeholder]);
        }

        return html;
    }

    private insertHtmlIntoModalPlaceholder(html: string): void {
        try {
            const placeholder = document.getElementById('workflowModalPlaceHolder');
            if (placeholder) {
                placeholder.innerHTML = html;
            }
        } catch (error) {
            console.error('Error when work done approval modal displayed:', error);
        }
    }

    private initializeModal(): void {
        const workflowModal = document.getElementById('workflowModal');
        if (workflowModal !== null) {
            this.modal = new Modal(workflowModal, { backdrop: 'static', keyboard: false });
        }
    }

    private configureModalElements(): void {
        this.configureEvidenceCheck();
        this.configureReasonTypeContainer();
        this.configureStatusChangeDateContainer();
        this.configureCompleteSRContainer();
        this.configureMessageRequirement();
        this.configureCommentsContainer();
        this.configureDateCompletionContainer();
        this.configureEngineerNameContainer();
        this.configureWorkOrderDetailsContainer();
        this.configureRequiresClientSignOffContainer();

        if (this.modal !== null) {
            const modalElement = document.getElementById('workflowModal');
            if (modalElement) {
                modalElement.addEventListener('shown.bs.modal', () => {
                    setTimeout(() => {
                        this.configureClientSignOffToggle();
                    }, 100);
                });
            }
            this.modal.show();
        }
    }

    private configureEvidenceCheck(): void {
        $("#evidenceCheck").hide();
        if (this.actionName === WOWorkflowActionNames.ACTION_RiskAssessmentFailed || this.actionName === WOWorkflowActionNames.ACTION_ConfirmRiskAssessmentPassed || this.actionName === WOWorkflowActionNames.ACTION_StartWorkRAPassed) {
            $("#evidenceCheck").show();
        }
    }

    private configureReasonTypeContainer(): void {
        $('#reasonTypeContainer').hide();
        if (this.failingCondition.mode === "Reason" || this.failingCondition.Mode === "CompleteAndReason") {
            this.showReasonTypeContainer();
        }
    }

    private showReasonTypeContainer(): void {
        $("#reasonType").show();
        $("#reasonTypeLabel").show();
        $('#reasonTypeContainer').show();
        if (this.failingCondition.defaultDropDownSystemCode !== null) {
            const ddlItem = $(`#reasonType option[data-systemcode='${this.failingCondition.defaultDropDownSystemCode}']`);
            ddlItem.prop("selected", true);
        }
        if (this.actionName === WOWorkflowActionNames.ACTION_RiskAssessmentFailed) {
            $('#reasonType').hide();
            $('#reasonTypeLabel').hide();
            $('#reasonTypeContainer').hide();
        }
        $('#reasonType').attr('required', '')
    }

    private configureStatusChangeDateContainer(): void {
        $('#statusChangeDateContainer').hide();
        if (this.failingCondition.mode === "SetDate") {
            this.showStatusChangeDateContainer();
        }
    }

    private showStatusChangeDateContainer(): void {
        $('#statusChangeDateContainer').show();
        const now = new Date();
        now.setMinutes(now.getMinutes() - now.getTimezoneOffset());
        const dateString = now.toISOString().substring(0, 16);
        $("#statusChangeDate").val(dateString);
       
        if (this.actionName === "Work Done") {
            let minDate = this.actualStartDate;
            if (minDate.length > 16) {
                minDate = minDate.substring(0, 16);
            }
            $('#statusChangeDate').attr('min', minDate);
        }
        $('#statusChangeDate').attr('required', '');
    }

    private configureCompleteSRContainer(): void {
        $('#completeSRContainer').hide();
        if (this.failingCondition.mode === "Complete" || this.failingCondition.Mode === "CompleteAndReason") {
            this.showCompleteSRContainer();
        }
    }

    private showCompleteSRContainer(): void {
        $('#completeSRContainer').show();
        $('#completeSR').attr('required', '');
    }

    private configureMessageRequirement(): void {
        if (this.failingCondition.isMessageMandatory) {
            $('#message').attr('required', '');
        }
    }

    private configureCommentsContainer(): void {
        if (this.actionName === WOWorkflowActionNames.ACTION_ApproveWork || this.actionName === WOWorkflowActionNames.ACTION_Resume) {
            $("#commentsContainer").hide();
        }
    }

    private configureDateCompletionContainer(): void {
        $('#dateCompletionContainer').hide();
        if (this.actionName === WOWorkflowActionNames.ACTION_WorkDone) {
            $('#dateCompletionContainer').show();
            const now = new Date();
            now.setMinutes(now.getMinutes() - now.getTimezoneOffset());
            const dateString = now.toISOString().substring(0, 16);
            $("#dateCompletion").val(dateString);
            $('#dateCompletion').attr('required', '');
        }
    }

    private configureEngineerNameContainer(): void {
        $('#engineerNameContainer').hide();
        if (this.actionName === WOWorkflowActionNames.ACTION_WorkDone) {
            $('#engineerNameContainer').show();
            $('#engineerName').attr('required', '');
        }
    }

    private configureWorkOrderDetailsContainer(): void {
        $('#workOrderDetailsContainer').hide();
        if (this.actionName === WOWorkflowActionNames.ACTION_WorkDone) {
            $('#workOrderDetailsContainer').show();
        }
    }

    private configureRequiresClientSignOffContainer(): void {
        $('#requiresClientSignOffContainer').hide();
        if (this.actionName === WOWorkflowActionNames.ACTION_WorkDone) {
            $('#requiresClientSignOffContainer').show();
        }
    }

    private updateWorkOrderDetails(dates: Dates): void {
        if (dates) {
            $('#propertyNameDisplay').text(dates.propertyName || '');
            $('#workOrderNameDisplay').text(dates.workOrderName || '');
            $('#assetNameDisplay').text(dates.assetName || '');
            $('#workOrderDescriptionDisplay').text(dates.workOrderDescription || '');

            let engineerName = '';

            const engineerNameFromPage = $('#workOrderEngineerName').val();
        
            if (engineerNameFromPage && typeof engineerNameFromPage === 'string') {
                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = engineerNameFromPage;
                engineerName = (tempDiv.textContent || tempDiv.innerText || '').trim();
            }

            if (!engineerName && dates.engineerName) {
                engineerName = dates.engineerName;
            }

            if (!engineerName) {
                const modalEngineerName = $('#modalEngineerName').val();

                if (modalEngineerName && typeof modalEngineerName === 'string') {
                    const tempDiv = document.createElement('div');
                    tempDiv.innerHTML = modalEngineerName;
                    engineerName = (tempDiv.textContent || tempDiv.innerText || '').trim();
                }
            }

            if (engineerName) {
                $('#engineerName').val(engineerName);
            }
        }
    }

    private initializeSignature(): void {
        const canvas = document.getElementById('signature') as HTMLCanvasElement;
        
        if (!canvas) {
            return;
        }
        
        const ctx = canvas.getContext('2d');
        if (!ctx) {
            return;
        }
        
        let isDrawing = false;
        let lastX = 0;
        let lastY = 0;
        
        ctx.strokeStyle = '#000000';
        ctx.lineWidth = 2;
        ctx.lineCap = 'round';
        ctx.lineJoin = 'round';
        
        const startDrawing = (e: MouseEvent | TouchEvent) => {
            isDrawing = true;
            const rect = canvas.getBoundingClientRect();
            if (e instanceof MouseEvent) {
                lastX = e.clientX - rect.left;
                lastY = e.clientY - rect.top;
            } else {
                lastX = e.touches[0].clientX - rect.left;
                lastY = e.touches[0].clientY - rect.top;
            }
        };
        
        const draw = (e: MouseEvent | TouchEvent) => {
            if (!isDrawing) return;
            e.preventDefault();
            
            const rect = canvas.getBoundingClientRect();
            let currentX, currentY;
            
            if (e instanceof MouseEvent) {
                currentX = e.clientX - rect.left;
                currentY = e.clientY - rect.top;
            } else {
                currentX = e.touches[0].clientX - rect.left;
                currentY = e.touches[0].clientY - rect.top;
            }
            
            ctx.beginPath();
            ctx.moveTo(lastX, lastY);
            ctx.lineTo(currentX, currentY);
            ctx.stroke();
            
            lastX = currentX;
            lastY = currentY;
        };
        
        const stopDrawing = () => {
            isDrawing = false;
        };
        
        canvas.addEventListener('mousedown', startDrawing);
        canvas.addEventListener('mousemove', draw);
        canvas.addEventListener('mouseup', stopDrawing);
        canvas.addEventListener('mouseout', stopDrawing);
        
        canvas.addEventListener('touchstart', startDrawing);
        canvas.addEventListener('touchmove', draw);
        canvas.addEventListener('touchend', stopDrawing);
        
        const clearButton = document.getElementById('clearSignature');
        if (clearButton) {
            clearButton.addEventListener('click', () => {
                ctx.clearRect(0, 0, canvas.width, canvas.height);
            });
        }
        
        this.signature = {
            canvas: canvas,
            value: () => {
                const isEmpty = !ctx.getImageData(0, 0, canvas.width, canvas.height).data.some(channel => channel !== 0);
                if (isEmpty) return '';
                return canvas.toDataURL('image/png');
            },
            clear: () => {
                ctx.clearRect(0, 0, canvas.width, canvas.height);
            }
        };
    }

    private configureClientSignOffToggle(): void {
        const checkbox = $('#requiresClientSignOff');
        const self = this;
        
        $('#workOrderApproveForm').off('change', '#requiresClientSignOff').on('change', '#requiresClientSignOff', function() {
            const isChecked = $(this).is(':checked');
            
            if (isChecked) {
                $('#customerNameContainer').show();
                $('#signatureContainer').show();
                $('#customerName').attr('required', '');
            } else {
                $('#customerNameContainer').hide();
                $('#signatureContainer').hide();
                $('#customerName').removeAttr('required');
                $('#customerName').removeClass('is-invalid');
                $('#signatureValidation').hide();
                if (self.signature !== null) {
                    self.signature.clear();
                }
            }
        });
    }

    private handleUserMessageSubmit(): void {
        $('#workflow-submitUserMessage').click(() => {
            if (this.isMessageMandatoryForSelectedReason()) {
                this.toggleMessageRequirement();
            }

            const form = this.getForm();
            if (form && this.isFormValid(form)) {
                this.saveMessage();
            }
        });
    }

    private isMessageMandatoryForSelectedReason(): boolean {
        return this.failingCondition.isMessageMandatory && this.failingCondition.dropdownCode === "Work Order Permit Reason";
    }

    private toggleMessageRequirement(): void {
        const selectedSystemCode = $('#reasonType option:selected').data("systemcode");
        if (selectedSystemCode !== this.failingCondition.defaultDropDownSystemCode) {
            $('#message').attr('required', '');
        } else {
            $('#message').removeAttr('required');
            this.failingCondition.isMessageMandatory = false;
        }
    }

    private getForm(): HTMLFormElement | null {
        return document.querySelector("#workOrderApproveForm");
    }

    private isFormValid(form: HTMLFormElement): boolean {
        const requiresClientSignOff = $('#requiresClientSignOff').is(':checked');
        
        if (requiresClientSignOff) {
            const customerName = $('#customerName').val() as string;
            let isValid = true;
            
            if (!customerName || customerName.trim() === '') {
                $('#customerName').addClass('is-invalid');
                isValid = false;
            } else {
                $('#customerName').removeClass('is-invalid');
            }
            
            if (this.signature !== null) {
                const signatureValue = this.signature.value();
                if (!signatureValue || signatureValue === '') {
                    $('#signatureValidation').show();
                    isValid = false;
                } else {
                    $('#signatureValidation').hide();
                }
            }
            
            if (!isValid) {
                return false;
            }
        }
        
        if (!form.checkValidity()) {
            form.classList.add('was-validated');
            return false;
        }
        return true;
    }

    private ComposeHeaderCss(): string {
        switch (this.actionName) {
            case WOWorkflowActionNames.ACTION_ReturnWorkOrder: return 'bg-red-dark';
            case WOWorkflowActionNames.ACTION_ApproveWork: return 'bg-green-dark';
            case WOWorkflowActionNames.ACTION_CancelWorkOrder: return 'bg-orange-dark';
            case WOWorkflowActionNames.ACTION_ConfirmRiskAssessmentPassed: return 'bg-blue-dark';
            case WOWorkflowActionNames.ACTION_StartWorkRAPassed: return 'bg-blue-dark';
            case WOWorkflowActionNames.ACTION_StartWork: return 'bg-green-dark';
            case WOWorkflowActionNames.ACTION_PutOnHold: return 'bg-orange-dark';
            case WOWorkflowActionNames.ACTION_Resume: return 'bg-green-dark';
            case WOWorkflowActionNames.ACTION_StartWorkNoRA: return 'bg-blue-dark';
            case WOWorkflowActionNames.ACTION_WorkDone: return 'bg-green-dark';
            case WOWorkflowActionNames.ACTION_RiskAssessmentFailed: return 'bg-red-dark';
            case WOWorkflowActionNames.ACTION_CancelWorkOrderAndCloseSR: return 'bg-orange-dark';
            case WOWorkflowActionNames.ACTION_PermitChecked: return 'bg-orange-dark';
            case WOWorkflowActionNames.ACTION_ApproveQuote: return 'bg-green-dark';
            case WOWorkflowActionNames.ACTION_RejectQuote: return 'bg-red-dark';
            case WOWorkflowActionNames.ACTION_SubmitQuote: return 'bg-blue-dark';
            case WOWorkflowActionNames.ACTION_ApproveQuoteDot: return 'bg-green-dark';
            case WOWorkflowActionNames.ACTION_CompleteQuoteApproval: return 'bg-green-dark';            
            default: return 'bg-night-light';
        }
    }

    private ComposeHeaderIconCss(): string {
        switch (this.actionName) {
            case WOWorkflowActionNames.ACTION_ReturnWorkOrder: return 'fa fa-undo color-white';
            case WOWorkflowActionNames.ACTION_ApproveWork: return 'fa fa-check color-white';
            case WOWorkflowActionNames.ACTION_CancelWorkOrder: return 'fa fa-ban color-white';
            case WOWorkflowActionNames.ACTION_ConfirmRiskAssessmentPassed: return 'fa fas fa-exclamation-triangle color-white';
            case WOWorkflowActionNames.ACTION_StartWorkRAPassed: return 'fa fas fa-exclamation-triangle color-white';
            case WOWorkflowActionNames.ACTION_StartWork: return 'fa fa-sign-out color-white';
            case WOWorkflowActionNames.ACTION_PutOnHold: return 'fa fa-pause color-white';
            case WOWorkflowActionNames.ACTION_Resume: return 'fa fa-play color-white';
            case WOWorkflowActionNames.ACTION_StartWorkNoRA: return 'fas fa-exclamation-triangle color-white';
            case WOWorkflowActionNames.ACTION_WorkDone: return 'fa fas fa-check color-white';
            case WOWorkflowActionNames.ACTION_RiskAssessmentFailed: return 'fa fas fa-exclamation-triangle color-white';
            case WOWorkflowActionNames.ACTION_CancelWorkOrderAndCloseSR: return 'fa fa-ban color-white';
            case WOWorkflowActionNames.ACTION_PermitChecked: return 'fas fa-exclamation-triangle color-white';
            case WOWorkflowActionNames.ACTION_ApproveQuote: return 'fa fa-check color-white';
            case WOWorkflowActionNames.ACTION_RejectQuote: return 'fa fa-ban color-white';
            case WOWorkflowActionNames.ACTION_SubmitQuote: return  'fa fa-check color-white';
            case WOWorkflowActionNames.ACTION_ApproveQuoteDot: return 'fa fa-check color-white';
            case WOWorkflowActionNames.ACTION_CompleteQuoteApproval: return 'fa fa-check color-white';
            default: return '';
        }
    }

    public _handle = (result: any, recordId: number, actionName: string, containerSelector: string): boolean => {
        if (result.failingConditionName !== this.CONDITION_NAME) {
            return false;
        }
        const cond = result.failingConditionName;
        this.failingCondition = result[cond.charAt(0).toLowerCase() + cond.slice(1)]; 
        this.validationMessage = result.message;
        this.recordId = recordId;
        this.actionName = actionName;
        this.containerSelector = containerSelector;
        this.title = this.failingCondition.title;
        this.promptUserForMessage();
        return true; 
    }

    public registerHandler() {
        const handler = new WorkflowWorkOrderApproveConditionHandler()._handle;
        WorkflowHandler.registerHandler(handler);        
    }  
}